import { BButton, BInput, BInputPassword } from "components/base";
import { ChangeEvent, FormEvent, useState } from "react";
import "./Form.scss";

type LoginFormValues = {
  username: string;
  password: string;
};

type LoginFormProps = {
  loading?: boolean;
  onSubmit?: (values: LoginFormValues) => void | Promise<void>;
};

const LoginForm = ({ loading = false, onSubmit }: LoginFormProps) => {
  const [form, setForm] = useState<LoginFormValues>({
    username: "",
    password: "",
  });

  const isSubmitDisabled = !form.username.trim() || !form.password.trim();

  const handleUsernameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({ ...prev, username: e.target.value }));
  };

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({ ...prev, password: e.target.value }));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitDisabled) return;
    await onSubmit?.(form);
  };

  return (
    <form className="login-page__form" onSubmit={handleSubmit}>
      <div className="login-page__form-field">
        <BInput
          id="username"
          name="username"
          type="text"
          value={form.username}
          placeholder="Tên đăng nhập"
          aria-label="Tên đăng nhập"
          size="large"
          autoComplete="username"
          onChange={handleUsernameChange}
        />
      </div>

      <div className="login-page__form-field">
        <BInputPassword
          id="userPassword"
          name="password"
          value={form.password}
          placeholder="Mật khẩu"
          aria-label="Mật khẩu"
          size="large"
          autoComplete="current-password"
          onChange={handlePasswordChange}
        />
      </div>

      <BButton
        htmlType="submit"
        size="large"
        loading={loading}
        disabled={isSubmitDisabled}
        className="b-button--block"
        type="primary"
      >
        Tiếp tục
      </BButton>
    </form>
  );
};

export default LoginForm;
